"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createConsultations = createConsultations;
const events_1 = require("../../../events");
const messages_1 = require("./messages");
const diabetology_1 = require("../../../forms/ktx/transplantation-screening/consultations/diabetology");
const queries_1 = require("../queries");
const shared_1 = require("../../shared");
const messages = {
    screeningProcedures: {
        id: "ktx.dashboard.consultations",
        defaultMessage: "Konzíliumok"
    }
};
const groups = [
    {
        label: messages_1.messages.cannotBePlacedOnList,
        variant: "dark",
        predicate: (event) => {
            return (event !== undefined &&
                event.value.result === diabetology_1.Result.CANNOT_BE_PLACED_ON_LIST);
        }
    },
    {
        label: messages_1.messages.canBePlacedOnList,
        variant: "light",
        predicate: (event) => event !== undefined &&
            event.value.result === diabetology_1.Result.CAN_BE_PLACED_ON_LIST
    }
];
const values = Object.values(queries_1.consultationQueries).map(query => ({
    query,
    label: shared_1.fsnMessages[(0, events_1.mapInterpretationToString)(query.interpretation)]
}));
function createConsultations(intl, { events }) {
    const list = (0, shared_1.createGroupList)(intl, { events, groups, values });
    const content = (0, shared_1.createSectionContent)([list]);
    return (0, shared_1.createSection)(intl, {
        label: messages.screeningProcedures,
        content
    });
}
